import React from 'react';
import CloseIcon from 'svg/CloseIcon';
import { Button } from 'components/Button';
import Modal from 'components/modals/Modal';

type VairConnectionAction = 'create' | 'join';

interface VairConnectionModalProps {
  isOpen: boolean;
  action?: VairConnectionAction;
  onClose: () => void;
  onConnect: () => void;
}

const ACTION_TEXT: Record<VairConnectionAction, string> = {
  create: 'create',
  join: 'join',
};

const VairConnectionModal: React.FC<VairConnectionModalProps> = ({
  isOpen,
  action,
  onClose,
  onConnect,
}) => {
  const actionText = action ? ACTION_TEXT[action] : 'create or join';
  return (
    <Modal isOpen={isOpen} handleClose={onClose} classNameMaxWidth="md:max-w-[25rem] xs:max-w-md">
      <div className="flex flex-col justify-between gap-8 px-6 pb-5 pt-6">
        <div className="flex flex-row justify-between text-left">
          <h3 className="typography-product-heading-compact text-left text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            Connect Your VAIR Account
          </h3>
          <button
            className="p-0.5 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary"
            type="button"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
        <p className="typography-product-body font-normal text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          To {actionText} a VAIR event, you need to connect your VAIR account. You'll be taken to
          VAIR to sign in or create an account.
        </p>
        <div className="flex w-full flex-col gap-3">
          <Button variant="primary" className="w-full" size="lg" onClick={onConnect}>
            Connect my VAIR
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default VairConnectionModal;
